import React, { FC, useEffect } from 'react';
import { SectionWrapper } from '../SectionWraper';
import { BUSINESS_INFORMATION_INPUTS } from '../../constants/profile-settings/business-settings-business-information';
import { useTranslation } from 'react-i18next';
import { FormInput } from '../merchants/FormInput';
import { useFormik } from 'formik';
import {
	businessInitialValues, convertToInitialBusiness,
	getBusinessDetailsSchema
} from '../../constants/profile-settings/business-settings-business-information-form';
import { ADDRESS_INFORMATION_INPUTS } from '../../constants/profile-settings/business-settings-address-information';
import { useMerchants } from '../../store/merchnts/merchants-context';

export const BusinessSettingsBusinessInformation: FC = () => {
	// const [isEditMode, setIsEditMode] = useState<boolean>(false);
	const { merchantState: { merchantsLists: lists, merchantData, isMerchantDataLoading }} = useMerchants();
	const { t } = useTranslation();

	const formik = useFormik({
		initialValues: businessInitialValues,
		validationSchema: getBusinessDetailsSchema(t),
		onSubmit: () => void 0
	});

	useEffect(() => {
		const data = convertToInitialBusiness(merchantData);
		formik.setValues(data);
	}, [merchantData]);

	// const handleEditClick = (): void => {
	// 	setIsEditMode(!isEditMode);
	// 	if (isEditMode) {
	// 		const params = getFormattedProfileSettingsFields(formik.values);
	// 		console.log('params', params);
	// 		toaster.push(toastMessage({
	// 			text: 'Preferences were saved!',
	// 			type: 'success'
	// 		}), { placement: 'topEnd' });
	// 	}
	// };

	const BUSINESS_INPUTS = BUSINESS_INFORMATION_INPUTS({ t, lists });
	const ADDRESS_INPUTS = ADDRESS_INFORMATION_INPUTS({ t, lists });

	return (
		<SectionWrapper
			title="MerchantBusinessPage information"
			sectionAdditionalClass="mb-5 min-height-400"
			pageLoading={isMerchantDataLoading}
			isCardBody
		>
			<div className="row">
				{
					BUSINESS_INPUTS.map(el => (
						<FormInput
							key={el.key}
							formik={formik}
							{...el}
							isEditMode={false}
						/>
					))
				}
			</div>
			<div className="row">
				{
					ADDRESS_INPUTS.map(el => (
						<FormInput
							key={el.key}
							formik={formik}
							{...el}
							isEditMode={false}
						/>
					))
				}
			</div>

		</SectionWrapper>
	);
};
